import { render, staticRenderFns } from "./EditCartMenu.vue?vue&type=template&id=ced1425c&scoped=true"
import script from "./EditCartMenu.vue?vue&type=script&lang=js"
export * from "./EditCartMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced1425c",
  null
  
)

export default component.exports